<template>
  <!-- Connect/Disconnect OpenId -->
  <div
    class="info_block"
    id="connect-open-id"
  >
    <h4 class="info_block_heading"> {{ $t("profile.open_id.heading") }}</h4>
    <div class="mb-24"></div>
    <div class="wrap-social-open-id--profile-page">
      <FacebookIconText />
      <GoogleIconText />
      <AppleIconText />
    </div>
  </div>
</template>

<script>
  import FacebookIconText from './open-id-buttons/FacebookIconText.vue'
  import GoogleIconText from './open-id-buttons/GoogleIconText.vue'
  import AppleIconText from './open-id-buttons/AppleIconText.vue'

  export default {
    components: {
      FacebookIconText,
      GoogleIconText,
      AppleIconText
    }
  }
</script>


// WEBPACK FOOTER //
// index.vue?fcbdb8f8